<template>
  <div class="iconAndButton" @click="handleControl" :style="buttonStyle">
    <i :class="icon" :style="iconStyle" />{{ title }}
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    // 图标颜色
    iconStyle: {
      type: Object,
      default: () => ({ color: '#17757A' })
    },
    // 按钮颜色
    buttonStyle: {
      type: Object,
      default: () => ({ marginRight: '10px' })
    },
    extraInfo: {
      type: Object,
      default: () => {}
    }
  },

  methods: {
    handleControl() {
      this.$emit('handleControl', this.title, this.extraInfo)
    }
  }
}
</script>

<style lang="less" scoped>
.iconAndButton {
  cursor: pointer;
  color: #1a1f33;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  i {
    margin-right: 4px;
  }
}
</style>
